var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 33,
    viewBox: "0 0 56 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send button"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "send button_2",
    width: 56,
    height: 33,
    rx: 16.5,
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1",
    d: "M17.6875 15.5C17.1352 15.5 16.6875 15.9477 16.6875 16.5C16.6875 17.0523 17.1352 17.5 17.6875 17.5V15.5ZM39.0262 17.2071C39.4167 16.8166 39.4167 16.1834 39.0262 15.7929L32.6622 9.42893C32.2717 9.03841 31.6385 9.03841 31.248 9.42893C30.8575 9.81946 30.8575 10.4526 31.248 10.8431L36.9049 16.5L31.248 22.1569C30.8575 22.5474 30.8575 23.1805 31.248 23.5711C31.6385 23.9616 32.2717 23.9616 32.6622 23.5711L39.0262 17.2071ZM17.6875 17.5L38.3191 17.5V15.5L17.6875 15.5V17.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.f5c32918b3466f7e814e124afd33adb5.svg";
export { ForwardRef as ReactComponent };